export default __webpack_public_path__ + "static/media/shipping_line.84053eb1.svg";